import * as React from "react";
const SvgFiRrSailboat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sailboat_svg__a)">
      <path
        fill="#062147"
        d="M23.607 16.274A2.64 2.64 0 0 0 21.337 15H2.657c-.929 0-1.776.474-2.265 1.266a2.6 2.6 0 0 0-.116 2.54C1.251 20.745 3.74 24 9.461 24h5.04c5.71 0 8.22-3.245 9.21-5.18a2.59 2.59 0 0 0-.104-2.546m-1.679 1.636C20.975 19.776 18.911 22 14.5 22H9.46c-4.415 0-6.459-2.226-7.396-4.093a.59.59 0 0 1 .031-.592.65.65 0 0 1 .562-.315h18.68c.333 0 .505.223.563.318a.59.59 0 0 1 .028.592M2.333 13h5.333c.624 0 1.21-.243 1.652-.685a2.32 2.32 0 0 0 .682-1.65L9.996 4.33c0-.961-.604-1.835-1.497-2.176a2.36 2.36 0 0 0-2.593.643L.6 9.106A2.333 2.333 0 0 0 2.334 13m-.226-2.581L7.413 4.11a.34.34 0 0 1 .25-.11c.255 0 .333.195.333.332L8 10.667a.33.33 0 0 1-.333.333H2.333a.33.33 0 0 1-.305-.2c-.053-.118-.03-.258.08-.381m10.576 1.897c.44.44 1.026.684 1.65.684h7.333a2.333 2.333 0 0 0 1.742-3.885L16.071.77a2.345 2.345 0 0 0-2.566-.617 2.345 2.345 0 0 0-1.5 2.178L12 10.665c0 .62.241 1.208.682 1.65zm1.32-9.981a.335.335 0 0 1 .574-.233l7.336 8.342c.088.099.11.239.058.358a.34.34 0 0 1-.305.198h-7.334a.337.337 0 0 1-.333-.334z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sailboat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSailboat;
